var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCoupons = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 25 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6B6B6B",
  d: "M3.929 0v.917c0 1.516-1.154 2.75-2.572 2.75H.5v9.166h.857c1.418 0 2.572 1.234 2.572 2.75v.917H21.07v-.917c0-1.516 1.154-2.75 2.572-2.75h.857V3.667h-.857c-1.418 0-2.572-1.234-2.572-2.75V0zm1.627 1.833h8.658v1.834h1.715V1.833h3.515v.004c.345 1.785 1.673 3.195 3.342 3.563v5.7c-1.67.369-2.998 1.78-3.342 3.567H15.93v-1.834h-1.715v1.834H5.556c-.344-1.787-1.67-3.206-3.342-3.574V5.407c1.671-.368 2.998-1.787 3.342-3.574M14.214 5.5v1.833h1.715V5.5zm0 3.667V11h1.715V9.167z"
})));
export default SvgCoupons;